var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.tab == "story"
    ? _c("StoryTab", {
        attrs: {
          tab: _vm.tab,
          mode: _vm.mode,
          files: _vm.files,
          isFileUploading: _vm.isFileUploading,
          dataFormRequest: _vm.dataFormRequest,
          saveAllFormData: _vm.saveAllFormData,
          formData: _vm.formData,
          previewMode: _vm.previewMode,
          idUsersAssigned: _vm.idUsersAssigned,
          requiredValidation: _vm.requiredValidation,
          canRestoreDraft: _vm.canRestoreDraft,
          draftInstance: _vm.draftInstance,
        },
        on: {
          assignUsers: _vm.assignUsers,
          unassignCurrentUser: _vm.unassignCurrentUser,
          addFile: _vm.uploadFile,
          generateFormData: _vm.generateFormData,
          generateDataFormRequest: _vm.handlePreGenerateDataFormRequest,
          saveDraft: _vm.saveDraft,
          restoreFormData: _vm.restoreFormData,
          saveFormData: _vm.saveFormData,
          changePreviewDisplay: _vm.changePreviewDisplay,
          sendPostAllPost: _vm.sendPostAllPost,
          migratePageSaveInMainSave: _vm.migratePageSaveInMainSave,
          retoreDraftInLocalStorage: _vm.retoreDraftInLocalStorage,
        },
      })
    : _vm.tab == "storification"
    ? _c("StorificationTab", {
        attrs: {
          tab: _vm.tab,
          mode: _vm.mode,
          files: _vm.files,
          isFileUploading: _vm.isFileUploading,
          dataFormRequest: _vm.dataFormRequest,
          saveAllFormData: _vm.saveAllFormData,
          formData: _vm.formData,
          previewMode: _vm.previewMode,
          idUsersAssigned: _vm.idUsersAssigned,
          requiredValidation: _vm.requiredValidation,
          canRestoreDraft: _vm.canRestoreDraft,
          draftInstance: _vm.draftInstance,
          storificationInstance:
            _vm.draftInstance.form.networks.instagram.storification,
        },
        on: {
          toogleStorificationTab: _vm.toogleStorificationTab,
          assignUsers: _vm.assignUsers,
          unassignCurrentUser: _vm.unassignCurrentUser,
          addFile: _vm.uploadFile,
          generateFormData: _vm.generateFormData,
          generateDataFormRequest: _vm.handlePreGenerateDataFormRequest,
          saveDraft: _vm.saveDraft,
          restoreFormData: _vm.restoreFormData,
          saveFormData: _vm.saveFormData,
          changePreviewDisplay: _vm.changePreviewDisplay,
          sendPostAllPost: _vm.sendPostAllPost,
          migratePageSaveInMainSave: _vm.migratePageSaveInMainSave,
          retoreDraftInLocalStorage: _vm.retoreDraftInLocalStorage,
        },
      })
    : _c("StandardTab", {
        attrs: {
          mode: _vm.mode,
          files: _vm.files,
          isFileUploading: _vm.isFileUploading,
          dataFormRequest: _vm.dataFormRequest,
          saveAllFormData: _vm.saveAllFormData,
          formData: _vm.formData,
          previewMode: _vm.previewMode,
          requiredValidation: _vm.requiredValidation,
          idUsersAssigned: _vm.idUsersAssigned,
          canRestoreDraft: _vm.canRestoreDraft,
          draftInstance: _vm.draftInstance,
          requests: _vm.requests,
        },
        on: {
          toogleStorificationTab: _vm.toogleStorificationTab,
          assignUsers: _vm.assignUsers,
          unassignCurrentUser: _vm.unassignCurrentUser,
          addFile: _vm.uploadFile,
          generateFormData: _vm.generateFormData,
          generateDataFormRequest: _vm.handlePreGenerateDataFormRequest,
          saveDraft: _vm.saveDraft,
          restoreFormData: _vm.restoreFormData,
          saveFormData: _vm.saveFormData,
          changePreviewDisplay: _vm.changePreviewDisplay,
          sendPostAllPost: _vm.sendPostAllPost,
          retoreDraftInLocalStorage: _vm.retoreDraftInLocalStorage,
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }